import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const _import = file => () => import('@/pages/' + file + '.vue')
const _importMobile = file => () => import('@/Mobile/' + file + '.vue')

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: _import('home/index'),
      redirect: '/index',
      children: [
        {
          path: 'index',
          component: _import('Index/index'),
          meta: { 'title': '首页' }
        },
        // {
        //   path: 'retail',
        //   component: _import('Solution/index'),
        //   meta: { 'title': '解决方案' }
        // },
        // {
        //   path: 'chainE',
        //   component: _import('Solution/ChainE'),
        //   meta: { 'title': '连锁电商' }
        // },
        // {
        //   path: 'cloud-purchase',
        //   component: _import('Solution/CloudPurchase'),
        //   meta: { 'title': '云采购' }
        // },
        // {
        //   path: 'community',
        //   component: _import('Solution/Community'),
        //   meta: { 'title': '社群分销' }
        // },
        // {
        //   path: 'live-broadcast',
        //   component: _import('Solution/LiveBroadcast'),
        //   meta: { 'title': '直播电商' }
        // },
        // {
        //   path: 'cashier',
        //   component: _import('Solution/Cashier'),
        //   meta: { 'title': '智能收银' }
        // },
        // {
        //   path: 'payment',
        //   component: _import('Solution/Payment'),
        //   meta: { 'title': '智能支付' }
        // },
        // {
        //   path: 'member',
        //   component: _import('Solution/Member'),
        //   meta: { 'title': '会员CRM' }
        // },
        // {
        //   path: 'popularize',
        //   component: _import('Solution/Popularize'),
        //   meta: { 'title': '流量推广' }
        // },
        // {
        //   path: 'brandCustom',
        //   component: _import('Solution/BrandCustom'),
        //   meta: { 'title': '品牌商城定制' }
        // },
        // {
        //   path: 'distributeCustom',
        //   component: _import('Solution/DistributeCustom'),
        //   meta: { 'title': '分销商城定制' }
        // },
        // {
        //   path: 'shopCustom',
        //   component: _import('Solution/ShopCustom'),
        //   meta: { 'title': '门店管理定制' }
        // },
        // {
        //   path: 'O2OCustom',
        //   component: _import('Solution/O2OCustom'),
        //   meta: { 'title': 'O2O定制' }
        // },
        // {
        //   path: 'B2B2C',
        //   component: _import('Solution/B2B2C'),
        //   meta: { 'title': 'B2B2C解决方案' }
        // },
        // {
        //   path: 'micromall',
        //   component: _import('Solution/Micromall'),
        //   meta: { 'title': '微商城' }
        // },
        {
          path: 'finance',
          component: _import('Industrial/Finance'),
          meta: { 'title': '金融服务' }
        },
        {
          path: 'supplychain',
          component: _import('Industrial/Supplychain'),
          meta: { 'title': '供应链服务' }
        },
        {
          path: 'aboutUs',
          component: _import('About/index'),
          meta: { 'title': '企业简介' }
        },
        {
          path: 'dynamic',
          component: _import('About/Dynamic'),
          meta: { 'title': '企业动态' }
        },
        {
          path: 'dynamicDetail/:id',
          component: _import('About/DynamicDetail'),
          meta: { 'title': '新闻中心正文' }
        },
        {
          path: 'agent-operation',
          component: _import('Industrial/AgentOperation'),
          meta: { 'title': '代运营服务' }
        },
        {
          path: 'cooperate',
          component: _import('EcoPartner/Cooperate'),
          meta: { 'title': '渠道合作' }
        },
        {
          path: 'eco-partner',
          component: _import('EcoPartner/index'),
          meta: { 'title': '生态伙伴' }
        },
        {
          path: 'QcErpSystem',
          component: _import('Solution/QcErpSystem'),
          meta: { 'title': '千橙ERP系统' }
        },
        {
          path: 'QcCashier',
          component: _import('Solution/QcCashier'),
          meta: { 'title': '千橙收银系统' }
        },
        {
          path: 'QcDistribution',
          component: _import('Solution/QcDistribution'),
          meta: { 'title': '千橙分销系统' }
        },
        {
            path: 'QcChain',
            component: _import('Solution/QcChain'),
            meta: { 'title': '千橙连锁系统' }
        },
        {
            path: 'QcShopkeeper',
            component: _import('Solution/QcShopkeeper'),
            meta: { 'title': '千橙新零售系统' }
        },
        {
            path: 'QcDigit',
            component: _import('Solution/QcDigit'),
            meta: { 'title': '千橙数字人' }
        },
        {
            path: 'QcShoppingMall',
            component: _import('Solution/QcShoppingMall'),
            meta: { 'title': '千橙微商城' }
        },
        {
            path: 'QcAssociation',
            component: _import('Solution/QcAssociation'),
            meta: { 'title': '汇团团社群营销系统' }
        },
        {
            path: 'QcMarketing',
            component: _import('Solution/QcMarketing'),
            meta: { 'title': '千橙会员营销系统' }
        },
        {
            path: 'QcCommerce',
            component: _import('Solution/QcCommerce'),
            meta: { 'title': '千橙电商S2B2C' }
        },
        {
            path: 'QcB2BChannel',
            component: _import('Solution/QcB2BChannel'),
            meta: { 'title': 'B2B渠道电商' }
        },
        {
            path: 'QcLiveBroadcast',
            component: _import('Solution/QcLiveBroadcast'),
            meta: { 'title': '汇好看直播电商' }
        },
        {
            path: 'QcTool',
            component: _import('Solution/QcTool'),
            meta: { 'title': '千橙RPA工具箱' }
        },
        {
            path: 'QcDownload',
            component: _import('Solution/QcDownload'),
            meta: { 'title': '产品下载聚合页' }
        },

      ]
    },
    {
      path: '/m',
      component: _importMobile('Home/index'),
      redirect: '/m/index',
      children: [
        {
          path: 'index',
          component: _importMobile('Index/index'),
          meta: { 'title': '首页' }
        },
        // {
        //   path: 'micromall',
        //   component: _importMobile('Solution/Micromall'),
        //   meta: { 'title': '微商城' }
        // },
        // {
        //   path: 'retail',
        //   component: _importMobile('Solution/index'),
        //   meta: { 'title': '零售电商' }
        // },
        // {
        //   path: 'chainE',
        //   component: _importMobile('Solution/ChainE'),
        //   meta: { 'title': '连锁电商' }
        // },
        // {
        //   path: 'cloud-purchase',
        //   component: _importMobile('Solution/CloudPurchase'),
        //   meta: { 'title': '云采购' }
        // },
        // {
        //   path: 'community',
        //   component: _importMobile('Solution/Community'),
        //   meta: { 'title': '社群分销' }
        // },
        // {
        //   path: 'live-broadcast',
        //   component: _importMobile('Solution/LiveBroadcast'),
        //   meta: { 'title': '直播电商' }
        // },
        // {
        //   path: 'B2B2C',
        //   component: _importMobile('Solution/B2B2C'),
        //   meta: { 'title': 'B2B2C' }
        // },
        // {
        //   path: 'finance',
        //   component: _importMobile('Industrial/Finance'),
        //   meta: { 'title': '金融服务' }
        // },
        // {
        //   path: 'supplychain',
        //   component: _importMobile('Industrial/Supplychain'),
        //   meta: { 'title': '供应链服务' }
        // },
        // {
        //   path: 'agent-operation',
        //   component: _importMobile('Industrial/AgentOperation'),
        //   meta: { 'title': '代运营服务' }
        // },
        // {
        //   path: 'cashier',
        //   component: _importMobile('Solution/Cashier'),
        //   meta: { 'title': '智能收银' }
        // },
        // {
        //   path: 'payment',
        //   component: _importMobile('Solution/Payment'),
        //   meta: { 'title': '智能支付' }
        // },
        // {
        //   path: 'member',
        //   component: _importMobile('Solution/Member'),
        //   meta: { 'title': '会员CRM' }
        // },
        // {
        //   path: 'popularize',
        //   component: _importMobile('Solution/Popularize'),
        //   meta: { 'title': '流量推广' }
        // },
        // {
        //   path: 'brandCustom',
        //   component: _importMobile('Solution/BrandCustom'),
        //   meta: { 'title': '品牌商城定制' }
        // },
        // {
        //   path: 'distributeCustom',
        //   component: _importMobile('Solution/DistributeCustom'),
        //   meta: { 'title': '分销商城定制' }
        // },
        // {
        //   path: 'shopCustom',
        //   component: _importMobile('Solution/ShopCustom'),
        //   meta: { 'title': '门店管理定制' }
        // },
        // {
        //   path: 'O2OCustom',
        //   component: _importMobile('Solution/O2OCustom'),
        //   meta: { 'title': 'O2O定制' }
        // },
        {
          path: 'cooperate',
          component: _importMobile('EcoPartner/Cooperate'),
          meta: { 'title': '渠道合作' }
        },
        {
          path: 'eco-partner',
          component: _importMobile('EcoPartner/Partner'),
          meta: { 'title': '生态伙伴' }
        },
        {
          path: 'introduce',
          component: _importMobile('EcoPartner/Introduction'),
          meta: { 'title': '企业简介' }
        },
        {
          path: 'dynamic',
          component: _importMobile('About/Dynamic'),
          meta: { 'title': '企业动态' }
        },
        {
          path: 'dynamicDetail/:id',
          component: _importMobile('About/DynamicDetail'),
          meta: { 'title': '新闻中心正文' }
        },
        {
            path: 'QcErpSystem',
            component: _importMobile('Solution/QcErpSystem'),
            meta: { 'title': '千橙ERP系统' }
          },
          {
            path: 'QcCashier',
            component: _importMobile('Solution/QcCashier'),
            meta: { 'title': '千橙收银系统' }
          },
          {
            path: 'QcDistribution',
            component: _importMobile('Solution/QcDistribution'),
            meta: { 'title': '千橙分销系统' }
          },
          {
              path: 'QcChain',
              component: _importMobile('Solution/QcChain'),
              meta: { 'title': '千橙连锁系统' }
          },
          {
              path: 'QcShopkeeper',
              component: _importMobile('Solution/QcShopkeeper'),
              meta: { 'title': '千橙新零售系统' }
          },
          {
              path: 'QcDigit',
              component: _importMobile('Solution/QcDigit'),
              meta: { 'title': '千橙数字人' }
          },
          {
              path: 'QcShoppingMall',
              component: _importMobile('Solution/QcShoppingMall'),
              meta: { 'title': '千橙微商城' }
          },
          {
              path: 'QcAssociation',
              component: _importMobile('Solution/QcAssociation'),
              meta: { 'title': '汇团团社群营销系统' }
          },
          {
              path: 'QcMarketing',
              component: _importMobile('Solution/QcMarketing'),
              meta: { 'title': '千橙会员营销系统' }
          },
          {
              path: 'QcCommerce',
              component: _importMobile('Solution/QcCommerce'),
              meta: { 'title': '千橙电商S2B2C' }
          },
          {
              path: 'QcB2BChannel',
              component: _importMobile('Solution/QcB2BChannel'),
              meta: { 'title': 'B2B渠道电商' }
          },
          {
              path: 'QcLiveBroadcast',
              component: _importMobile('Solution/QcLiveBroadcast'),
              meta: { 'title': '汇好看直播电商' }
          },
          {
              path: 'QcTool',
              component: _importMobile('Solution/QcTool'),
              meta: { 'title': '千橙RPA工具箱' }
          },
          {
            path: 'QcDownload',
            component: _importMobile('Solution/QcDownload'),
            meta: { 'title': '产品下载聚合页' }
           },
           {
            path: 'Register',
            component: _importMobile('Solution/Register'),
            meta: { 'title': '注册登录页' }
        },
        {
          path: 'TryModalPage',
          component: _importMobile('Mobilecom/TryModalPage'),
          meta: { 'title': '信息收集' }
      },
      ]
    },

    {
      path: '/404',
      component: _import('ErrorPages/404')
    },
    {
      path: '/information',
      component: _import('Information/index')
    },
    {
        path: '/registerLogin',
        component: _importMobile('RegisterLogin/registerLogin')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
